<template>
  <div>
    <el-form :model="uploadForm" ref="upload" :rules="rules" label-width="120px" label-position="right">
      <el-form-item prop="files" label="选择文件">
        <el-upload ref="upload" name="file" :on-change="handleChange" :file-list="fileList" action="" :http-request="httpRequest" :on-remove='removeList' class="prod_upload3">
          <el-input readonly style="width:100%"></el-input>
        </el-upload>
      </el-form-item>
      <el-form-item prop="docComments" label="文件描述">
        <el-input v-model="uploadForm.docComments" type="textarea" maxlength="100" show-word-limit style="width:100%"></el-input>
      </el-form-item>
      <el-form-item prop="reportType" label="附件类型">
        <el-select v-model="uploadForm.reportType" clearable placeholder="请选择" style="width:100%">
          <el-option :key="index" v-for="(item,index) in partyTypeOptions" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="uploading('ruleForm')">上传</el-button>
        <el-button @click="close">取消</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { fileService } from "@/api/common/file-utils"
import QBRApi from "@/api/QBR/index";
export default {
  props: ['bizId', 'recType'],
  data() {
    return {
      fileList: [],
      fileData: [],
      uploadForm: {
        files: [],
        docComments: "",
        reportType: "",
      },
      partyTypeOptions: [
        {
          label: "MGG审核报告",
          value: '301',
        },
        {
          label: "GGAP审核报告",
          value: '302',
        },
        {
          label: "GGAP认证证书",
          value: '303',
        },
        {
          label: "MGG整改报告",
          value: '304',
        },
        {
          label: "GGAP整改报告",
          value: '305',
        }
      ],
      rules: {
        files: [
          { required: true, message: '请上传文件', trigger: 'blur' },
        ],
        docComments: [
          { required: true, message: '请输入文件描述', trigger: 'blur' },
        ],
        reportType: [
          { required: true, message: '请选择文件类型', trigger: 'change' },
        ],
      },
    };
  },

  created() {
  },

  computed: {},

  methods: {
    httpRequest(param) {
      this.uploadForm.files.push(param.file)
    },
    handleChange(file, fileList) {
      console.log('file', file);
      console.log('fileList', fileList);
      this.fileList = fileList.slice(-1);
      if (fileList.length > 1) {
        this.uploadForm.files.splice(0, 1)
      }
    },
    uploading() {
      console.log('this.uploadForm', this.uploadForm.files);
      this.$refs['upload'].validate((valid) => {
        if (valid) {
          let formData = new FormData();
          console.log('formData', formData);
          this.uploadForm.files.forEach((v) => {
            console.log("vvvvvvvvvvvvvv", v)
            formData.append('file', v, v.name)
          })
          fileService.fileUpload(formData).then((res) => {
            console.log('res', res);
            console.log('bizId', this.bizId);
            console.log('recType', this.recType);
            let attachment = {};
            attachment.documents = res.data[0];
            attachment.documents.docComments = this.uploadForm.docComments
            attachment.seq = this.uploadForm.reportType;
            attachment.tsRecId = this.bizId;
            attachment.tsReckindId = this.recType;
            fileService.saveFile(attachment).then((saveRes) => {
              if (saveRes.code == 200) {
                this.$message.success('保存成功')
                this.$emit('close')
              } else {
                this.$message.error(res.msg)
              }
            })
          }).catch((error) => {
            console.log('error', error);
            //文件上传失败
            this.$message.error('文件上传失败')
          });
        }
      })
    },
    removeList(file, fileList) {
      this.uploadForm.files = fileList
      if (fileList.length == 0) {
        this.uploadForm.files = []
      }
    },
    close() {
      this.$emit('close')
    }
  }
}

</script>
<style  scoped>
</style>
